<template>
  <div class="servicepopup">
    <el-dialog :visible.sync="visible" :show-close="false" width="460px">
      <div class="content">
        <img src="@/static/new/img/login/login_logo.webp" class="logo" alt="" />
        <div class="box" v-if="itemData">
          <div class="box_l">
            <div class="label">证据类型：</div>
            <div class="label">证据份数：</div>
            <div class="label">证据合同：</div>
            <div class="label">合同编号：</div>
            <div class="label">申 请 人：</div>
            <div class="label">申请时间：</div>
            <div class="label">出证进度：</div>
            <div class="label" v-if="itemData.certificateType === 0&& itemData.state === 2">操 作：</div>
          </div>
          <div class="box_r">
            <div class="value">
              {{ EnumRender(itemData.certificateType, certificateType) }}
            </div>
            <div class="value">1份</div>
            <div class="value">{{ itemData.contract.subject }}</div>
            <div class="value">{{ itemData.contract.contractNo }}</div>
            <div class="value">{{ itemData.emp.name }}</div>
            <div class="value">
              {{ itemData.updatedAt | timeFormat("yyyy-mm-dd hh:MM") }}
            </div>
            <div
              class="value"
              :style="`color:${
                itemData.state == 0
                  ? '#F45858'
                  : itemData.state == 1
                  ? '#0062FF'
                  : itemData.state == 2
                  ? '#00C152'
                  : '#666666'
              }`"
            >
              {{ EnumRender(itemData.state, certificateState) }}
            </div>
            <div class="value primary pointer" @click="onDownload" v-if="itemData.certificateType === 0 && itemData.state === 2">下载</div>
          </div>
        </div>
        <img
          src="@/assets/image/close2.webp"
          class="close"
          alt=""
          srcset=""
          @click="visible = false"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectData from "@/mixins/selectData";
export default {
  components: {},
  mixins: [selectData],
  data() {
    return {
      visible: false,
      itemData: null,
    };
  },
  created() {},
  computed: {},
  methods: {
    onShow(itemData) {
      this.visible = true;
      this.itemData = itemData;
    },
    onclose() {
      this.visible = false;
      this.itemData = null;
    },
    onDownload() {
      this.$emit("onDownload", this.itemData);
    }
  },
};
</script>

<style scoped lang="scss">
.servicepopup {
  @include popupNo;
  &::v-deep .el-dialog {
    border-radius: 20px;
  }
}
.content {
  width: 460px;
  height: 650px;
  background-image: url(~@/assets/image/issue/popupBg.webp);
  background-size: 100% auto;
  position: relative;
  .logo{
    width: 140px;
    height: 30px;
    position: absolute;
    left: 160px;
    top: 124px;
  }
  .box {
    display: flex;
    gap: 11px;
    font-size: 14px;
    color: #666666;
    position: absolute;
    top: 194px;
    left: 150px;
    &_l,
    &_r {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    &_l {
      .label {
        width: 70px;
        display: flex;
        justify-content: space-between;
      }
    }
    &_r {
      .value {
      }
    }
  }
  .close {
    width: 28px;
    height: 28px;
    position: absolute;
    bottom: -48px;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
}
</style>
